import React, { useRef, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { Box } from 'transfix-ui/core'
import { useUserDetails } from 'utils/hooks/useUserDetails'
import { useDeclineOffer } from 'apps/fleet-planner/hooks/useDeclineOffer'
import { Button, Spinner } from 'transfix-ui'

export const DeclineOfferPage = () => {
  const history = useHistory()
  const { logout } = useUserDetails()
  const { authErrorMessage, isLoading, loginAndDecline } = useDeclineOffer()
  /**
   * When this component mounts, log in the user with token param
   */
  const hasTriggeredDecline = useRef(false)
  useEffect(() => {
    if (!hasTriggeredDecline.current) {
      hasTriggeredDecline.current = true
      loginAndDecline()
    }
  }, [history, loginAndDecline])

  return (
    <Box p={10} display='flex' alignItems='center' justifyContent='center' flexDirection='column'>
      {isLoading && (
        <Box>
          <Spinner position='relative' />
        </Box>
      )}
      {!isLoading && authErrorMessage && (
        <Box p={3} textAlign='center'>
          <Box pb={5}>
            <InlineMessage
              message={authErrorMessage}
              type={INLINE_MESSAGE_VARIANTS.ALERT}
              fullWidth
            />
          </Box>
          <Box>
            <Button color='primary' size='large' fullWidth onClick={() => logout()}>
              Log In to FMS
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  )
}
